// extracted by mini-css-extract-plugin
export default {"WidgetWrapper":"WidgetWrapper_WidgetWrapper__3WDZz","WidgetWrapperContainer":"WidgetWrapper_WidgetWrapperContainer__KGxfe","Widget":"WidgetWrapper_Widget__2F1bK"};